import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './LoginView.module.css';
import { logger } from '../../utils/logger';

// ① Propsの型定義を追加
export interface LoginViewProps {
  onGoogleLogin: () => Promise<void>;
  onAnonymousLogin: () => Promise<void>;
}

// ② propsを受け取って使うよう変更
const LoginView: React.FC<LoginViewProps> = ({ onGoogleLogin, onAnonymousLogin }) => {
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError('');
    setIsLoading(true);

    try {
      await onGoogleLogin(); // props経由で実行
      navigate('/Top');
    } catch (err: any) {
      if (err && typeof err === 'object' && 'code' in err) {
        setError('Googleログインに失敗しました。もう一度お試しください。');
        logger.error('Google login error with code:', err.code, err);
      } else {
        setError('予期せぬエラーが発生しました。');
        logger.error('Unknown login error:', err);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <span className="text-4xl font-extrabold text-gradient from-cyan-500 to-violet-500">QuizA</span>
        {error && <div className={styles.errorMessage}>{error}</div>}
        <button
          onClick={handleLogin}
          disabled={isLoading}
          className={styles.googleLoginButton}
        >
          <img
            src="https://www.google.com/favicon.ico"
            alt="Google logo"
            className={styles.googleLogo}
          />
          {isLoading ? 'ログイン中...' : 'Googleでログイン'}
        </button>
        <div className="mt-6 text-sm text-gray-600 text-center">
          <p>
            <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:underline">利用規約</a>
            <span>　</span>
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:underline">プライバシーポリシー</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginView;
